import {addOrUpdateItem, removeItem} from './../../../helpers'

export default (moduleName) => {
    let scModuleName = _.snakeCase(moduleName).replace(/_/g, '-')

    let module = {
        namespaced: true,

        state: {
            items: []
        },

        actions: {
            fetch (store, params = {}) {
                return axios.get(`/api/${scModuleName}`, { params })
                    .then(res => {
                        _.each(res.data.data, item => store.dispatch('processItem', item))
                        return res
                    })
            },

            create (store, item = {}) {
                return axios.post(`/api/${scModuleName}`, item)
                    .then(res => {
                        store.dispatch(`processItem`, res.data.data)
                        return res
                    });
            },

            update (store, item) {
                return axios.patch(`/api/${scModuleName}/${item.id}`, item)
                    .then(res => {
                        store.dispatch(`processItem`, res.data.data)
                        return res
                    })
            },

            createOrUpdate (store, item = []) {
                item.project_id = store.rootGetters.currentProjectId

                return item.id
                    ? store.dispatch(`update`, item)
                    : store.dispatch('create', item)
            },

            remove (store, item) {
                // let projectId = store.rootGetters.currentProjectId

                // todo confirm action
                // return axios.delete(`/api/projects/${projectId}/${scModuleName}/${item.id}`)
                return axios.delete(`/api/${scModuleName}/${item.id}`)
                    .then(res => {
                        store.commit(`remove`, item)
                        return res
                    })
            },

            processItem(store, moduleItem) {
                if (moduleItem.applicant) {
                    store.dispatch('processContact', moduleItem.applicant, { root: true })
                    delete(moduleItem.applicant)
                }

                if (moduleItem.respondent) {
                    store.dispatch('processContact', moduleItem.respondent, { root: true })
                    delete(moduleItem.respondent)
                }

                store.commit(`addOrUpdate`, moduleItem)
            }
        },

        mutations: {
            addOrUpdate: (state, item) => {
                addOrUpdateItem(state, item)
            },

            remove: (state, item) => removeItem(state, item)
        },

        getters: {
            projectItems(state) {
                return state.items
            },

            currentProjectItems(state, getters, rootState, rootGetters) {
                return _.filter(state.items, {
                    project_id: rootGetters.currentProjectId
                })
            },

            itemById (state) {
                return id => _.find(state.items, {id})
            },

            itemsByIds(state) {
                return (ids) => {
                    let items = []
                    _.each(ids, id => {
                        let item = _.find(state.items, {id})
                        if (item) items.push(item)
                    })

                    return items
                }
            }
        }
    }

    return _.cloneDeep(module)
}
